import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "StarsLayout" */ './StarsLayout'),
  modules: ['./StarsLayout'],
  loading: () => null
});

export default LoadableWidget;
